module.exports = __webpack_public_path__ + "static/media/dialogBg.ca421172.png";